import React, { FC } from 'react';
import { Flex, Link, Icon } from 'roo-ui/components';
import { Logo, ScrollToTopButton } from '../primitives';

const scrollTop = () => window.scrollTo(0, 0);

interface ScrollTopProps {
  landingPageUrl: string;
  footerLogoSrc: string;
  footerLogoLabel: string;
}

export const ScrollToTop: FC<ScrollTopProps> = ({
  landingPageUrl,
  footerLogoSrc,
  footerLogoLabel,
}) => (
  <Flex my={8} justifyContent="space-between">
    <Link href={landingPageUrl} data-testid="footer-logo-link">
      <Logo
        src={footerLogoSrc}
        alt={'Qantas'}
        role="img"
        aria-label={footerLogoLabel}
        data-testid="footer-logo"
      />
    </Link>
    <ScrollToTopButton
      mt={-44}
      onClick={scrollTop}
      data-testid="scroll-to-top"
      aria-label="Scroll to top"
    >
      <Icon name="expandLess" />
    </ScrollToTopButton>
  </Flex>
);
